export default [{
  path: 'rentAppraisalList',
  name: 'rentAppraisalList',
  component: function component() {
    return import('@/views/bidManage/rentAppraisalManage/index');
  }
}, {
  path: 'rentAppraisalAdd',
  name: 'rentAppraisalAdd',
  component: function component() {
    return import('@/views/bidManage/rentAppraisalManage/add');
  }
}, {
  path: 'rentAppraisalDetail',
  name: 'rentAppraisalDetail',
  component: function component() {
    return import('@/views/bidManage/rentAppraisalManage/detail');
  }
}, {
  path: 'rentAppraisalSuccess',
  name: 'rentAppraisalSuccess',
  component: function component() {
    return import('@/views/bidManage/rentAppraisalManage/success');
  }
}, {
  path: 'rentAppraisalUpdate',
  name: 'rentAppraisalUpdate',
  component: function component() {
    return import('@/views/bidManage/rentAppraisalManage/update');
  }
}];